import { ActionContext } from 'vuex';

import { ActionClass, AppState } from '../../../models';

import { APP_CONSTS } from '../app.consts';

export class SetFiltersHiddenAction implements ActionClass {

  public static execute({ commit }: ActionContext<AppState, any>, filtersHidden: boolean): void {
    commit(APP_CONSTS.mutations.setFiltersHidden, filtersHidden);
  }

}
